
import React, { useState } from 'react';
import Bg from '../../images/shapes/shape_title_under_line.svg';
import shape1 from '../../images/shapes/shape_line_2.svg';
import shape2 from '../../images/shapes/shape_line_3.svg';
import shape3 from '../../images/shapes/shape_line_4.svg';
import shape4 from '../../images/shapes/shape_space_3.svg';
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import { useParams } from 'react-router-dom';

const FaqSection = () => {
    const [open, setOpen] = useState('1');
    const { slug } = useParams();

    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    console.log(slug);
    
    // FAQ content by slug
    const getFaqContentBySlug = () => {
        switch(slug) {
            case 'seo-services':
                return {
                    heading: 'FAQs – SEO Services in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'How long does it take SEO to deliver results?',
                            answer: 'SEO is a long-term solution, not a quick solution. Typically, significant improvements will show in 3–4 months, subject to competition, condition of the website, and selected keywords. In highly competitive areas, achieving excellent first-page rankings could take six to eight months. Increasing results requires consistency, creating high-quality content, and establishing connections.'
                        },
                        {
                            id: '2',
                            question: 'What is Local SEO and why is it significant for Alwar businesses?',
                            answer: 'Local SEO makes your company show up in search terms such as "best SEO services in Alwar" or "near me." It is essential for shops, small businesses, and service providers who are targeting a local market. With Local SEO, your Google Business Profile is optimized, customer reviews are taken care of, and your business can own local map pack rankings, fetching you more local customers.'
                        },
                        {
                            id: '3',
                            question: 'How does RashTech Info ensure safe and effective SEO practices?',
                            answer: 'At RashTech Info, we strictly adhere to white-hat SEO methods sanctioned by Google. Our procedure involves keyword research, on-page optimization, quality content writing, technical SEO audits, and authoritative link building. We do not use black-hat practices that can damage rankings. We believe in long-term success, as we want your site to attain consistent growth and stability in organic traffic.'
                        },
                        {
                            id: '4',
                            question: 'Do you offer tailor-made SEO packages for various businesses?',
                            answer: 'Yes, we do recognize that each company is different. RashTech Info offers tailored SEO packages to startups, SMEs, and businesses. If you are a local store in Alwar or have a business to serve national and global markets, we create adaptable SEO plans that suit your objectives and investment to yield measurable returns.'
                        },
                        {
                            id: '5',
                            question: 'Why should I opt for RashTech Info when there are other SEO Company in Alwar?',
                            answer: 'RashTech Info is reputed as the Best SEO Agency in Alwar because we merge years of experience with successful outcomes. We have assisted clients to grow since 2018 with clear reporting, low-cost plans, and customer-centric approaches. Unlike generic agencies, we concentrate on customized SEO that generates rankings, traffic, and actual conversions for your company.'
                        }
                    ]
                };
            case 'app-development-services':
                return {
                    heading: 'FAQs – App Development in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'Do you offer both Android and iOS app development?',
                            answer: 'Yes, we build Android, iOS, as well as hybrid apps on the latest frameworks to provide seamless performance on all devices.'
                        },
                        {
                            id: '2',
                            question: 'An app takes how long to make?',
                            answer: 'Simple apps would take 2–3 months, and complex apps with custom functionalities can take 4–6 months based on requirements.'
                        },
                        {
                            id: '3',
                            question: 'Do you provide app support after release?',
                            answer: 'Yes, we offer complete maintenance encompassing bug fixes, updates, and security patches to ensure your app remains dependable.'
                        },
                        {
                            id: '4',
                            question: 'Can you undertake projects beyond Alwar or India?',
                            answer: 'Certainly! We provide services to clients in India and overseas, including USA, UK, UAE, Canada, and Australia.'
                        },
                        {
                            id: '5',
                            question: 'Why is RashTech Info the Best App Development Company in Alwar?',
                            answer: 'We have since 2018 provided high-quality, affordable, and bespoke apps through transparent processes and demonstrable outcomes.'
                        }
                    ]
                };
            case 'smo-services':
                return {
                    heading: 'FAQs – SMO Services in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'On which platforms do you offer SMO services?',
                            answer: 'We handle all major platforms such as Facebook, Instagram, LinkedIn, Twitter, and YouTube.'
                        },
                        {
                            id: '2',
                            question: 'How does SMO benefit my business?',
                            answer: 'SMO makes your brand more visible on the web, drives more engagement, and enables you to reach out to potential customers.'
                        },
                        {
                            id: '3',
                            question: 'Do you provide social media content creation?',
                            answer: 'Yes, we create interesting graphics, posts, and videos that match your brand personality.'
                        },
                        {
                            id: '4',
                            question: 'Whether you can execute paid campaigns with SMO?',
                            answer: 'Yes, we execute targeted advertisement campaigns to acquire more customers and generate more conversions.'
                        },
                        {
                            id: '5',
                            question: 'Why is RashTech Info the Best SMO Company in Alwar?',
                            answer: 'We have been serving affordable, innovative, and effective SMO services since 2018, which are trusted by businesses across the globe.'
                        }
                    ]
                };
            case 'graphic-design-services':
                return {
                    heading: 'FAQs – Graphic Design Services in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'Do you provide graphic design services for print and digital?',
                            answer: 'Yes, we design digital media like websites and social media profiles as well as print materials like flyers, brochures, and packaging.'
                        },
                        {
                            id: '2',
                            question: 'How long does it take to develop a design?',
                            answer: 'That varies from project to project. Small designs would require a few days, and branding or larger projects would require a few weeks.'
                        },
                        {
                            id: '3',
                            question: 'Do you design custom logo and brand identity?',
                            answer: 'Yes, absolutely! We design personalized logos and brand sets reflecting your business personality and values.'
                        },
                        {
                            id: '4',
                            question: 'Do you take projects beyond Alwar or India?',
                            answer: 'Yes, RashTech Info provides Graphic Design Services in India and globally with clients from the USA, UK, UAE, Canada, and Australia.'
                        },
                        {
                            id: '5',
                            question: 'Why is RashTech Info the Best Graphic Design Company in Alwar?',
                            answer: 'We have been providing creative, affordable, and result-oriented graphic designs since 2018 that make companies stand out.'
                        }
                    ]
                };
            case 'video-editing-services':
                return {
                    heading: 'FAQs – Video Editing Services in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'What types of video editing services do you provide?',
                            answer: 'We provide corporate, promo, social media, product, event, and customized video editing.'
                        },
                        {
                            id: '2',
                            question: 'How long does it take to edit a video?',
                            answer: 'Small cuts would be back within 3 days, and big jobs would be done in 1–3 weeks as per specifications.'
                        },
                        {
                            id: '3',
                            question: 'Are you offering video editing for YouTube and social media?',
                            answer: 'Yes, we are expert in social media videos, YouTube video editing, and online-optimized videos.'
                        },
                        {
                            id: '4',
                            question: 'Do you accept projects out of Alwar or India?',
                            answer: 'Yes! We provide our services to India-based clients and worldwide clients in the USA, UK, UAE, Canada, and Australia.'
                        },
                        {
                            id: '5',
                            question: 'RashTech Info is Alwar\'s Best Video Editing Company. Why?',
                            answer: 'We have been providing creative, cost-effective, and professional video editing services that are relied upon by businesses from all over the globe since 2018.'
                        }
                    ]
                };
            case 'ui-ux-development-services':
                return {
                    heading: 'FAQs – UI/UX Development in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'Do you offer UI/UX design for websites and mobile applications?',
                            answer: 'Yes, we offer UI/UX design for websites, Android & iOS applications, and enterprise software.'
                        },
                        {
                            id: '2',
                            question: 'How much time is required to design a UI/UX project?',
                            answer: 'Timelines are based on complexity. Simple projects are done in 2–4 weeks, and big platforms can take a few months.'
                        },
                        {
                            id: '3',
                            question: 'Do you offer redesign services for websites or apps that have already been created?',
                            answer: 'Of course, yes! We examine your current design and make necessary improvements to increase performance, appearance, and use.'
                        },
                        {
                            id: '4',
                            question: 'Do you provide international UI/UX services?',
                            answer: 'Yes, RashTech Info has clients in India as well as worldwide, including the USA, UK, UAE, Canada, and Australia.'
                        },
                        {
                            id: '5',
                            question: 'Why RashTech Info the Best UI/UX Development Company in Alwar?',
                            answer: 'We have provided innovative, intuitive, and business-oriented designs relied upon by international clients since 2018.'
                        }
                    ]
                };
            case 'custom-software-services':
                return {
                    heading: 'FAQs – Custom Software Development in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'Do you offer custom software for small as well as large organizations?',
                            answer: 'Yes, we create customized solutions for startups, SMEs, and companies based on their specific needs.'
                        },
                        {
                            id: '2',
                            question: 'How long does it take to create custom software?',
                            answer: 'It depends on complexity. Simple tools could take 2–3 months, while advanced enterprise applications could take 6+ months.'
                        },
                        {
                            id: '3',
                            question: 'Do you provide support after delivering the software?',
                            answer: 'Yes! We offer extended maintenance, updates, and feature additions for all our projects.'
                        },
                        {
                            id: '4',
                            question: 'Do you work on projects outside Alwar or India?',
                            answer: 'Yes, RashTech Info offers services to clients based in India as well as the global world, such as USA, UK, UAE, Canada, and Australia.'
                        },
                        {
                            id: '5',
                            question: 'Why choose RashTech Info for custom software development?',
                            answer: 'We have been offering reliable, safe, and scalable solutions that help businesses enjoy measurable growth since 2018.'
                        }
                    ]
                };
            case 'e-commerce-solutions-services':
                return {
                    heading: 'FAQs – E-commerce Solutions in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'What platforms do you support for e-commerce development?',
                            answer: 'We support well-known platforms such as Shopify, WooCommerce, Magento, and we also have custom solutions designed according to your requirement.'
                        },
                        {
                            id: '2',
                            question: 'Do you design e-commerce websites that are mobile-friendly?',
                            answer: 'Yes, all of our e-commerce solutions are responsive and mobile, tablet, and desktop optimized.'
                        },
                        {
                            id: '3',
                            question: 'Do you offer payment gateway integration?',
                            answer: 'Yes, definitely! We integrate secure and trusted payment gateways such as Razorpay, PayPal, Stripe, and others.'
                        },
                        {
                            id: '4',
                            question: 'Do you provide e-commerce projects beyond Alwar?',
                            answer: 'Yes, RashTech Info provides E-commerce Services in India and worldwide with clients in the USA, UK, UAE, Canada, and Australia.'
                        },
                        {
                            id: '5',
                            question: 'How is RashTech Info the Best E-commerce Solutions Company in Alwar?',
                            answer: 'We have provided scalable, secure, and customized e-commerce solutions with transparent processes and successful outcomes since 2018.'
                        }
                    ]
                };
            case 'web-development-services':
                return {
                    heading: 'FAQs – Web Development Services in Alwar',
                    items: [
                        {
                            id: '1',
                            question: 'What is the time it takes to build a webpage?',
                            answer: 'Timeline is decided based on the type and complexity of your website. A simple business site can take 2–3 weeks, whereas a complex e-commerce or custom web application can take 6–8 weeks. We give you transparent timelines upfront to facilitate smooth delivery.'
                        },
                        {
                            id: '2',
                            question: 'Will my website be mobile-friendly and responsive?',
                            answer: 'Yes. All websites we design are completely responsive and tested on all devices—desktops, tablets, and smartphones. We make sure your website offers a smooth user experience on each screen size.'
                        },
                        {
                            id: '3',
                            question: 'Once a website is launched, do you provide maintenance and support?',
                            answer: 'Absolutely. We provide maintenance and support packages to maintain your website updated, secure, and in top working order. We can assist with everything from bug fixes to updating content.'
                        },
                        {
                            id: '4',
                            question: 'Do you design e-commerce websites?',
                            answer: 'Yes. We create robust and scalable e-commerce websites with functionalities such as product catalog, secure payment gateway, inventory management, and easy checkout procedures.'
                        },
                        {
                            id: '5',
                            question: 'Why should I prefer RashTech Info compared to other web development Company in Alwar?',
                            answer: 'Since 2018, RashTech Info has been relied upon by 200+ companies globally for professional, personalized, and affordable web solutions. Generic agencies don\'t come with that approach we focus on websites that are not just appearance-driven but also performance-oriented, leading to higher customer interaction and conversions.'
                        }
                    ]
                };
            default:
                return {
                    heading: 'Frequently Asked Questions',
                    items: [
                        {
                            id: '1',
                            question: 'What services do you provide?',
                            answer: 'We offer a wide range of digital services including web development, app development, SEO, SMO, graphic design, and more.'
                        },
                        {
                            id: '2',
                            question: 'How long does a typical project take?',
                            answer: 'Project timelines vary based on complexity, but we always provide clear estimates before starting any work.'
                        },
                        {
                            id: '3',
                            question: 'Do you work with clients outside of Alwar?',
                            answer: 'Yes, we serve clients both locally in Alwar and internationally.'
                        },
                        {
                            id: '4',
                            question: 'What is your pricing model?',
                            answer: 'We offer flexible pricing models based on project requirements, including fixed-price and hourly options.'
                        },
                        {
                            id: '5',
                            question: 'How can I get started with a project?',
                            answer: 'Simply contact us through our website or phone, and we\'ll schedule a consultation to discuss your project needs.'
                        }
                    ]
                };
        }
    };

    const faqs = getFaqContentBySlug();
    console.log(faqs);
    

    return (
        <section className="process_technology_review_section bg-light section_decoration">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10"> {/* accordion will take full width */}
                        <div className="heading_block text-center">
                            <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                                Frequently Asked Questions
                            </div>
                            <h2 className="heading_text mb-4">
                                {/* {slug?.replace('-', ' ')} <mark>FAQs</mark> */}
                                {faqs.heading}
                            </h2>
                        </div>
                        <Accordion open={open} toggle={toggle} id="faq_section" className="accordion">
                            {faqs.items.map((item) => (
                                <AccordionItem key={item.id} className="accordion-item">
                                    <AccordionHeader targetId={item.id}>
                                        {item.question}
                                    </AccordionHeader>
                                    <AccordionBody accordionId={item.id} className="acc_body">
                                        <p className="m-0">{item.answer}</p>
                                    </AccordionBody>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>

            {/* Decorative shapes */}
            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="RashTech Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="RashTech Shape" />
            </div>
            <div className="decoration_item shape_image_3">
                <img src={shape3} alt="RashTech Shape" />
            </div>
            <div className="decoration_item shape_image_4">
                <img src={shape4} alt="RashTech Shape" />
            </div>
        </section>
    );
};

export default FaqSection;
